export const SINGLE_VALUE = 'one';
export const MULTIPLE_VALUE = 'other';
